import React, { useState, useMemo } from 'react';
import { Pagination } from 'react-bootstrap';

const SHOW_PAGE = 7;

export default function PaginationBootstrap({
  onPageClick,
  total,
  pageSize = 10,
}) {
  const [current, setCurrent] = useState(0);

  const handlePageChange = (page) => {
    setCurrent(page);
    onPageClick(page);
  };

  const pages = useMemo(
    () =>
      Array.from({ length: Math.ceil(total / pageSize) }, (_, index) => index),
    [total, pageSize]
  );

  const showPages = useMemo(() => {
    if (pages.length <= SHOW_PAGE) {
      return pages.slice(1, pages.length - 1);
    }
    if (current - 1 - (SHOW_PAGE - 1) / 2 < 0) {
      return pages.slice(1, SHOW_PAGE);
    }
    if (current + (SHOW_PAGE - 1) / 2 > pages.length - 2) {
      return pages.slice(pages.length - SHOW_PAGE - 1, pages.length - 1);
    }
    return pages.slice(
      current - (SHOW_PAGE - 1) / 2,
      current + (SHOW_PAGE - 1) / 2 + 1,
    );
  }, [pages, current]);

  return (
    <Pagination>
      <Pagination.First
        disabled={current === 0}
        onClick={() => handlePageChange(0)}
      />
      <Pagination.Prev
        disabled={current === 0}
        onClick={() => handlePageChange(current - 1)}
      />
      {pages.length > 0 && (
        <Pagination.Item
          key={0}
          active={current === 0}
          onClick={() => handlePageChange(0)}
        >
          {1}
        </Pagination.Item>
      )}
      {pages.length > SHOW_PAGE && current - (SHOW_PAGE - 1) / 2 > 1 && (
        <Pagination.Ellipsis disabled />
      )}
      {showPages
        .map((index) => (
          <Pagination.Item
            key={index}
            active={index === current}
            onClick={() => handlePageChange(index)}
          >
            {index + 1}
          </Pagination.Item>
        ))}
      {pages.length > SHOW_PAGE &&
        current + (SHOW_PAGE - 1) / 2 < pages.length - 2 && (
          <Pagination.Ellipsis disabled />
        )}
      {pages.length > 1 && (
        <Pagination.Item
          key={pages.length - 1}
          active={current === pages.length - 1}
          onClick={() => handlePageChange(pages.length - 1)}
        >
          {pages.length}
        </Pagination.Item>
      )}
      <Pagination.Next
        disabled={current === pages.length - 1}
        onClick={() => handlePageChange(current + 1)}
      />
      <Pagination.Last
        disabled={current === pages.length - 1}
        onClick={() => handlePageChange(pages.length - 1)}
      />
    </Pagination>
  );
}
